import Keycloak from "keycloak-js";
import { sleep } from "@/utils";

export const keycloakInit = async () => {
  let keycloak = new Keycloak({
    url: `${process.env.VUE_APP_KEYCLOAK_HOST}/auth`,
    realm: `${process.env.VUE_APP_KEYCLOAK_REALM}`,
    clientId: `${process.env.VUE_APP_KEYCLOAK_CLIENT_ID}`,
  });
  keycloak
    .init({
      onLoad: "check-sso",
      responseType: "code",
      silentCheckSsoRedirectUri:
        window.location.origin +
        `${process.env.VUE_APP_GLOBAL_BASE_URL}` +
        "/silent-check-sso.html",
      pkceMethod: "S256",
    })
    .then((authenticated) => {
      if (!authenticated) {
        keycloak.login();
      }
    });
  await sleep(2000);
  return keycloak;
};
